import React from 'react';
import ReactQuill from 'react-quill';

import css from '../input/input.module.scss';
import 'react-quill/dist/quill.snow.css';

interface Props {
    name: string;
    label: string;
    error?: string;
    value: string;
    placeholder: string;
    onChange: (text: string) => void;
}

const TextEditor: React.FC<Props> = (otherProps) => {
	const getFieldClassName = (): string => {
		let defaultClass: string = css['form-input-group-field'];
		if (otherProps.error) defaultClass += ` ${css['form-input-group-invalid']}`;

		return defaultClass;
	};

	const getContainerClassName = (): string => {
		let defaultClass: string = css['form-input-group-container'];
		if (otherProps.error) defaultClass += ` ${css['form-input-group-invalid']}`;

		return defaultClass;
	};

	return (
		<div className={css['form-input-group']}>
			{otherProps.label && <label htmlFor={otherProps.name}>{otherProps.label}:</label>}

			<div className={getContainerClassName()} style={{ height: '100%' }}>
                <ReactQuill 
					className={getFieldClassName()}
                    theme="snow"
                    value={otherProps.value}
                    onChange={otherProps.onChange}
                    placeholder={otherProps.placeholder}
                />
			</div>

			{otherProps.error && <div className="error">{otherProps.error}</div>}
		</div>
	);
};

export default TextEditor;
